var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "train-video-wrapper" },
    [
      _c(
        "div",
        {
          staticStyle: { display: "flex", "align-items": "center" },
          on: {
            click: function ($event) {
              _vm.drawer = true
            },
          },
        },
        [
          _c("img", {
            staticClass: "train-video-img",
            attrs: { src: require("@/assets/image/trainVideo.png"), alt: "" },
          }),
          _c("span", { staticClass: "train-video-text" }, [_vm._v("培训")]),
        ]
      ),
      _c(
        "el-drawer",
        {
          attrs: {
            title: "伏羲云培训视频",
            visible: _vm.drawer,
            "append-to-body": "",
            "before-close": _vm.beforeClose,
            "custom-class": "train-video",
          },
          on: {
            "update:visible": function ($event) {
              _vm.drawer = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticStyle: { padding: "0 20px" } },
            [
              _c(
                "el-row",
                {
                  staticStyle: {
                    "margin-bottom": "15px",
                    "padding-right": "14px",
                  },
                  attrs: { type: "flex", justify: "space-between" },
                },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 20 } },
                    [
                      _c("el-input", {
                        attrs: {
                          clearable: "",
                          placeholder: "输入视频名称搜索",
                        },
                        on: { clear: _vm.search },
                        model: {
                          value: _vm.value,
                          callback: function ($$v) {
                            _vm.value = $$v
                          },
                          expression: "value",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 3 } },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.search },
                        },
                        [_vm._v("搜索")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 4 } },
                _vm._l(_vm.list, function (item, index) {
                  return _c("el-col", { key: index, attrs: { span: 8 } }, [
                    _c(
                      "div",
                      {
                        staticClass: "img-for-cls",
                        on: {
                          click: function ($event) {
                            return _vm.toShowVideo(item)
                          },
                        },
                      },
                      [
                        _c("img", { attrs: { src: item.posterUrl } }),
                        _c("i", { staticClass: "el-icon-video-play" }),
                      ]
                    ),
                    _c(
                      "div",
                      { staticClass: "video-name text_hidden_1" },
                      [
                        _c("textShowMore", {
                          attrs: { text: item.videoName, "line-clamp": 1 },
                        }),
                      ],
                      1
                    ),
                  ])
                }),
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }